import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  background-color: ${props => (props.dark ? props.theme.bgLight : props.theme.bg2)};
  padding: 32px 0 31px 0;
  text-align: center;

  ${media.medium`
    display: block;
    padding: 120px 0 100px 0;
  `}
`;
